import jwt from 'jwt-decode';
import axios from 'axios';
import servicioObjetos from './ServicioObjetos';
import { BASE_URL } from './ServicioConstantes';
import { TOKEN_QUADRUM_IMSS, USUARIO_KEY } from './ServicioConstantes';
import { BEARER } from './ServicioConstantes';

var instanciaAxios = axios.create({
    baseURL: BASE_URL
});

export function setToken(token) {
    localStorage.setItem(TOKEN_QUADRUM_IMSS, token);
}

export function deleteToken() {
    localStorage.removeItem(TOKEN_QUADRUM_IMSS);
}

export function setUsuario(usuario) {
    localStorage.setItem(USUARIO_KEY, usuario);
}

export function getUsuario() {
    return localStorage.getItem(USUARIO_KEY);
}

export function deleteUsuario() {
    localStorage.removeItem(USUARIO_KEY);
}

export function getToken(config) {
    return new Promise((resolve, reject) => {
        let tokenLocalStorage = localStorage.getItem(TOKEN_QUADRUM_IMSS);
        if (!servicioObjetos.esObjetoVacio(tokenLocalStorage)) {
            let tokenDecodificado = jwt(tokenLocalStorage.replace(BEARER, ""));
            let expiracionToken = new Date(tokenDecodificado.exp * 1000);
            let ahora = new Date();
            if (expiracionToken < ahora) {
                if (!servicioObjetos.esObjetoVacio(config)) {
                    let usuario = getUsuario();
                    let refreshToken = tokenDecodificado.jti;
                    let urlPost = '/renovar.json?user=' + usuario + '&refreshToken=' + refreshToken;
                    instanciaAxios.post(urlPost, null).then(response => {
                        let token = response.headers.authorization;
                        setToken(token);
                        resolve(token);
                    }).catch(error => {
                        reject(error);
                        window.location = "/idsenube";
                    });
                }
            } else {
                resolve(tokenLocalStorage);
            }
        } else {
            resolve(null);
        }
    });
}